var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 17.3333C3.26346 17.3333 2.6665 16.7363 2.6665 16C2.6665 15.2636 3.26346 14.6666 3.99984 14.6666L24.7809 14.6666L23.057 12.9428C22.5363 12.4221 22.5363 11.5778 23.057 11.0572C23.5777 10.5365 24.4219 10.5365 24.9426 11.0572L28.9426 15.0572C29.4633 15.5778 29.4633 16.4221 28.9426 16.9428L24.9426 20.9428C24.4219 21.4635 23.5777 21.4635 23.057 20.9428C22.5363 20.4221 22.5363 19.5779 23.057 19.0572L24.7809 17.3333H3.99984Z",
    fill: "#6E7C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.d5cf355e.svg";
export { ForwardRef as ReactComponent };